import {Subscription} from 'rxjs';
import {OnDestroy, OnInit} from '@angular/core';
import {AppStatus} from './@models/app-status';
import {Menu} from '../shared-gen/Model/Menus/Menu';
import {PriceList} from '../shared-gen/Model/PriceLists/PriceList';
import {MenuFun} from '../shared/model/menus/menu.fun';
import {PriceListFun} from '../shared/model/price-lists/price-list.fun';
import {DeviceStatus} from '../shared-gen/Device/Status/DeviceStatus';
import {DeviceStatusFun} from '../shared/device/device-status.fun';
import {Localized} from '../shared/localized';
import {AppService} from './services/app.service';
import { ExtendedPriceList } from "../shared-gen/Model/PriceLists/ExtendedPriceList";
import { ExtendedPriceListFun } from "../shared/model/price-lists/extended-price-list.fun";

export class StatusListener extends Localized implements OnInit, OnDestroy {

	menu: Menu = MenuFun.createNew('');
	pricelist: ExtendedPriceList = ExtendedPriceListFun.createNew('');
	deviceStatus: DeviceStatus = DeviceStatusFun.offline();

	private statusListener: Subscription;

	constructor(protected app: AppService) {
		super(app.translation);
	}

	ngOnInit() {
		super.ngOnInit();
		this.statusListener = this.app.status.appStatus.subscribe(status => {
			this.onStatusChanged(status);
		});
	}

	ngOnDestroy() {
		super.ngOnDestroy();
		if (this.statusListener)
			this.statusListener.unsubscribe();
	}

	onStatusChanged(status: AppStatus) {
		this.deviceStatus = status.deviceStatus;
		this.menu = status.menu;
		if (status.deviceStatus.VendingStatus != null) {
			this.pricelist = status.deviceStatus.VendingStatus.PriceList;
		}
	}

}
